import { BridgeAction } from '@omni/kit/Types';

export const isBlockPageContentHandler = (
  action: BridgeAction | null | undefined
): boolean => {
  if (action?.handler === 'blockPage') {
    const actionUrl = action.url;
    const actionType = action?.type;

    return Boolean(actionUrl && actionType === 'content');
  }

  return false;
};

export const isLocationBasedAction = (
  action: BridgeAction | null | undefined
): action is BridgeAction => {
  const url = action?.url ?? action?.contentUrl;

  return Boolean(url && url?.includes('{lat}') && url?.includes('{lng}'));
};

export const getActionUrl = (
  action: BridgeAction | null | undefined
): string => {
  return action?.url ?? '';
};
